import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslationKey, UTCDate } from "@ankaadia/ankaadia-shared";
import { NewUiButton, translateSafely } from "@ankaadia/ankaadia-shared-frontend";
import { LingokingTableType } from "@ankaadia/graphql";
import { TranslocoService } from "@jsverse/transloco";
import { MessageService, SelectItemGroup } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { FloatLabel } from "primeng/floatlabel";
import { MultiSelectModule } from "primeng/multiselect";
import { catchError, of } from "rxjs";
import { UtcFixDirective } from "../../shared/directives/utc-fix.directive";
import { WriteTablesService } from "../../shared/write-tables.service";
import { ExcelBaseComponent } from "../excel-base/excel-base.component";
import { LingokingDataService } from "./lingoking-data.service";

@Component({
  selector: "app-lingoking-data",
  styleUrl: "./lingoking-data.component.scss",
  templateUrl: "./lingoking-data.component.html",
  imports: [CalendarModule, UtcFixDirective, FormsModule, MultiSelectModule, NewUiButton, FloatLabel],
})
export class LingokingDataComponent extends ExcelBaseComponent implements OnInit {
  myDate: UTCDate[] | undefined;
  groupedOrganizations!: SelectItemGroup[];
  selectedOrganizations!: string[];

  dateSelectorState = "";
  organizationSelectorState = "";
  tableSelectorState = "";

  tableTypes: any[] = Object.keys(LingokingTableType).map((key) => {
    return { label: translateSafely(`lingokingTableType.${LingokingTableType[key]}` as TranslationKey), value: key };
  });

  selectedTableType: string[];
  constructor(
    private readonly lingokingData: LingokingDataService,
    override readonly transloco: TranslocoService,
    override readonly messageService: MessageService,
    private readonly writeTablesService: WriteTablesService
  ) {
    super(transloco, messageService);
  }

  ngOnInit(): void {
    this.getOrganizations();
  }

  resetDateSelector(): void {
    this.dateSelectorState = "";
  }

  resetOrganizationSelector(): void {
    this.organizationSelectorState = "";
  }

  resetTableSelector(): void {
    this.tableSelectorState = "";
  }

  getOrganizations(): void {
    this.lingokingData.getOrganizationData().subscribe((d) => {
      if (d) {
        this.groupedOrganizations = [
          {
            label: translateSafely("officeAddin.licensedOrganizations"),
            items: d.organizations
              .filter((x) => x.isLicensed)
              .map((org) => {
                return { label: org.name, value: org.organizationId, isLicensed: org.isLicensed };
              }),
          },
          {
            label: translateSafely("officeAddin.unlicensedOrganizations"),
            items: d.organizations
              .filter((x) => !x.isLicensed)
              .map((org) => {
                return { label: org.name, value: org.organizationId, isLicensed: org.isLicensed };
              }),
          },
        ];
      }
    });
  }

  getData(): void {
    let invalid = false;
    if (!this.myDate) {
      this.dateSelectorState = "invalid-entry";
      invalid = true;
    }
    if (!this.selectedTableType || this.selectedTableType.length === 0) {
      this.tableSelectorState = "invalid-entry";
      invalid = true;
    }
    if (!this.selectedOrganizations || this.selectedOrganizations.length === 0) {
      this.organizationSelectorState = "invalid-entry";
      invalid = true;
    }
    if (invalid) return null;
    this.setBusy(true);
    this.lingokingData
      .getLingokingData(
        this.language,
        this.myDate?.[0],
        this.myDate?.[1] ?? this.myDate[0],
        this.selectedTableType.map((type) => type as LingokingTableType),
        this.selectedOrganizations
      )
      .pipe(
        catchError((error) => {
          this.sendFailureMessage(error);
          this.setBusy(false);
          return of(null);
        })
      )
      .subscribe(async (d) => {
        if (d) {
          const result = await this.writeTablesService.writeDataToManyTables(d, false);
          this.sendTableUpdateMessage(result);
          this.setBusy(false);
        }
      });
  }
}
